
import type { PropType } from 'vue'
import { computed, defineComponent, getCurrentInstance } from 'vue'
import EpbLoading from '../../shared/epb-loading/epb-loading.component.vue'
import ToolReportingNoResults from './no-results.component.vue'

export enum DataStateEnum {
  LOADING = 'loading',
  LOADED = 'loaded',
  NO_RESULTS = 'noResults',
}

export default defineComponent({
  name: 'ToolReportingDataStateHandler',
  components: {
    EpbLoading,
    ToolReportingNoResults,
  },
  props: {
    dataState: {
      type: String as PropType<DataStateEnum>,
      required: true,
    },
  },
  setup(props) {
    const {
      proxy: { $epb },
    } = getCurrentInstance()

    const baseClass = 'epb-tool-reporting-data-state-handler'
    const messages = $epb.messages.insights.toolReporting

    const isLoading = computed(() => props.dataState === DataStateEnum.LOADING)
    const isLoaded = computed(() => props.dataState === DataStateEnum.LOADED)
    const isNoResults = computed(() => props.dataState === DataStateEnum.NO_RESULTS)

    return {
      messages,
      baseClass,
      isLoading,
      isLoaded,
      isNoResults,
    }
  },
})
